<template lang="pug">
	.json-editor(v-if="showed")
		.card
			.card-header
				i.fa.fa-pencil
				span {{domain}}
			.card-body
				.loading-wrapper(v-show="state === 'loading'")
					.icon.fa.fa-spinner.fa-spin
					span {{`Fetching ${domain} JSON`}}
				.content(v-show="state === 'loaded'" ref="editorElement")
				.error(v-show="state === 'error'")
					span {{error}}
			.card-footer
				button.btn.btn-secondary(type="button" v-on:click="hide()") Cancel
				button.btn.btn-primary(v-show="state === 'loaded'" type="submit" v-on:click="save()") Save
</template>
<script>
	import Screen 				from './../../mixins/screen';
	import { Template } 		from "@/services/Template";
	import SetupSettings 		from "@/settings/settings.json";
	import JSONEditor 			from 'jsoneditor';

	export default {
		name: "JsonEditor",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;

			return {
				domain: '',
				value: '',
				state: 'loading',
				error: ''
			}
		},
		methods: {
			collectData(action, domain) {

				this.state = 'loading';
				this.domain = domain;

				if (!domain) return;

				const fileName = domain ? domain + '.json' : 'websites.json';
				const fileFolder = 'websites';

				const url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

				fetch(url).then(response => {
					return response.json();
				}).then(json => {

					this.value = JSON.stringify(json);

					this.editor = new JSONEditor(this.$refs.editorElement, {mode: 'code'});
					this.editor.set(json);

					this.state = 'loaded';

				}).catch(error => {

					this.state = 'error';
					this.error = error;

				});


			},

			save() {

				this.editor.validate().then(validationResults => {

					if (validationResults.length) {

						Broadcast.call("Show Error Notification", ['JSON Validation Error', validationResults[0].message]);

					} else {

						Template.uploadJsonText(this.editor.getText(), this.domain);

						this.hide();

					}

				});

			}
		}
	}
</script>

<style lang="sass">
	.json-editor
		position: absolute
		z-index: 2000
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		width: 100%
		height: 100%

		>.card
			width: 80%
			min-height: 500px
			max-height: 80%

			>.card-body
				height: 500px

				>.content
					height: 100%

				>.loading-wrapper
					height: 100%
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center

					.icon
						display: inline
						font-size: 30px

			>.card-footer
				display: flex
				justify-content: space-between

</style>
